import { render, staticRenderFns } from "./EventEditForm.vue?vue&type=template&id=cb952dfa&scoped=true"
import script from "./eventEditFrom.js?vue&type=script&lang=js&external"
export * from "./eventEditFrom.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb952dfa",
  null
  
)

export default component.exports